// React Hooks

// LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Presentation: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section id="presentation" className="space-ptb">
            <div className="container-fluid w-special">
                <div className="row justify-content-around align-items-center">
                    <div className="col-12 col-lg-8 order-lg-2 mb-4 mb-lg-0">
                        <h2 className="mb-4 w-para" dangerouslySetInnerHTML={{ __html: t('homePage.presentation.title') as string }} />
                        <p className="mb-4 w-para" dangerouslySetInnerHTML={{ __html: t('homePage.presentation.para1') as string }} />
                        <Link to={'/chi-siamo'} className="btn btn-primary" title={t('homePage.presentation.linkTitle')as string}>
                            {t('homePage.presentation.linkText')}
                        </Link>
                    </div>
                    <div className="col-12 col-sm-9 col-md-6 col-lg-4 col-xl-3 order-lg-1 mb-4">
                        <div className="img-wrapper">
                            <img src="/assets/images/inHome/lidoC.png" alt={t('homePage.presentation.imgAlt') as string}/>
                        </div>
                    </div>
                </div>
            </div>
            <img src="/assets/images/rainbow.png" alt="rainbow" className="rainbow" />
        </section>
    )
}
export default Presentation;